<template>
	<div>
		<div class="supervisorRank">
			<div class="titleIcon marb25">
				<div class="inlin">
					<i :class="`iconfont ${icon} tableIcon`"></i>
					<span class="fz16">{{title}}</span>
				</div>
				<div class="exportTab marl20" v-if="this.hospitalResultParameter.type == 2">
					<div class="sliderScreeningR">
						<a href="javascript:;" @click="seachTab(2)" :class="DashboradArr.type==2?'active':''">审核医生</a>
						<a href="javascript:;" @click="seachTab(4)" :class="DashboradArr.type==4?'active':''">诊断医生</a>
					</div>
				</div>
			</div>
			<div class="mart25 postr">
				<template>
					<el-table class="qcTable qcHeight scrollbar" :data="list">
						<template slot="empty">
							<div class="echartsNull">
								<div>
									<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
								</div>
								<div class="text">暂无数据</div>
							</div>
						</template>
						<el-table-column prop="DoctorName" label="姓名"></el-table-column>
						<el-table-column prop="HospitalRank" label="院内排名"></el-table-column>
						<el-table-column prop="SampledNum" label="抽样数"></el-table-column>
						<el-table-column prop="AvgScore" label="平均分"></el-table-column>
						<el-table-column prop="MaxScore" label="最高分"></el-table-column>
						<el-table-column prop="MinScore" label="最低分"></el-table-column>
						<el-table-column prop="UnqualifiedCount" label="不合格（份）"></el-table-column>
						<el-table-column prop="IsSeriousCount" label="严重扣分（份）"></el-table-column>
						<el-table-column prop="" label="操作">
							<template slot-scope="scope">
								<span class="tableOpe" @click="qualifiedClick(scope.row,'qualified')">查看报告</span>
							</template>
						</el-table-column>
					</el-table>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default {
		props: ['FirstApprovers', 'Technicians', 'Submitters', 'icon', 'title', 'type', 'tabType'],
		data() {
			return {
				DashboradArr: {
					type: 2
				},
				list: []
			}
		},
		computed: {
			...Vuex.mapState('centralStatistics', ['trigger', 'hospitalResultParameter', 'reportDate']),
			...Vuex.mapState('supervisor', ['QualifiedPart', 'breadcrumbList', 'slider', 'GetReportListArr','HospitalAVGScoreArr']),

			triggers() {
				return this.trigger.flag;
			}
		},
		watch: {
			triggers(old) {
				if (old) {
					this.seachTab(2);
				}
			},
			type(old) {
				if (old) {
					this.seachTab(2);
				}
			}
		},
		activated() {
			if (this.tabType) {
				this.seachTab(2);
			} else {
				this.seachTab(this.DashboradArr.type);
			}
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'settableLoading', 'setLoading',
				'setBreadcrumbList'
			]),
			//合格医生点击
			qualifiedClick(row, type) {
				this.setLoading(true);
				this.settableLoading(true);
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.HospitalAVGScoreArr.type = this.hospitalResultParameter.type == 1 ? 3 : this.DashboradArr.type;
				this.QualifiedPart.hospitalGuid = this.hospitalResultParameter.hospitalGuid;
				this.QualifiedPart.doctorName = row.DoctorName;
				this.QualifiedPart.type = type;
				this.setBreadcrumbList();
				this.GetReportListArr.type = "医生列表";
				this.GetReportListArr.name = '';
				this.breadcrumbList.push(this.reportDate.data[0] + '-' + this.reportDate.data[1]);
				this.breadcrumbList.push(row.DoctorName);
				this.$router.push("/home/supervisor/qualifiedTable");
				this.breadcrumbList.push("doctor");
			},
			seachTab(type) {
				this.DashboradArr.type = type;
				if (this.type == 2) {
					this.list = type == 2 ? this.FirstApprovers : this.Submitters;
				} else {
					this.list = this.Technicians;
				}
				this.$emit('doctorTab', type);
			}
		},
	}
</script>
<style type="text/css" scoped="scoped">
	.bigScreen .supervisorPages .supervisorRank {
		padding-left: 20px;
		padding-right: 20px;
	}

	.doctorPage .pages {
		margin: 20px 0 0;
	}

	.qcHeight {
		height: auto !important;
	}
</style>
